import React from 'react';

// Types
import Locale from '@/types/locale';
import { FormattedMessage, formatMessageWithLocale } from '@/utils/i18n';
import moment from 'moment';
import CommonInception from '@/types/common-inception';

interface Props {
  commonInception?: CommonInception;
  locale?: Locale;
}

export default function CommonInceptionDateDisclaimer({ commonInception, locale }: Props) {
  const startDate = commonInception?.startTimestamp;

  if (!startDate) {
    return null;
  }

  const date = moment.utc(startDate).format(formatMessageWithLocale('Common.DateFormats.Short', locale));

  return (
    <div className="disclaimer" style={{ display: 'block' }}>
      <FormattedMessage id="Disclaimers.CommonInceptionDate" values={{ date }} locale={locale} />
    </div>
  );
}
